// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ib-draggable[data-v-641db94a] .sortable-ghost{opacity:0}", ""]);
// Exports
module.exports = exports;
